import { notification as AntNotification } from 'antd';

/**
 * Wrapper for Ant Design Notification API
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * Notification is a static API (not a component), so we export it directly.
 *
 * @module Notification
 * @example
 * import { notification } from '../GeneralComponents/ui';
 *
 * // Success notification
 * notification.success({
 *   message: 'Success',
 *   description: 'This is a success message',
 * });
 *
 * // Error notification
 * notification.error({
 *   message: 'Error',
 *   description: 'This is an error message',
 * });
 *
 * // Info notification
 * notification.info({
 *   message: 'Info',
 *   description: 'This is an info message',
 * });
 *
 * // Warning notification
 * notification.warning({
 *   message: 'Warning',
 *   description: 'This is a warning message',
 * });
 *
 * @see https://ant.design/components/notification/ - Ant Design Notification documentation
 */
const notification = AntNotification;

export default notification;
